import React, { useMemo } from 'react';
import { FormGroup, ControlLabel, FormControl } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import _ from 'lodash';

import * as types from '../../reducer/constants';
import { getRefillValue } from './helper';
import { getNumberValue } from '../../helper';

const FieldRefillDays = ({ form, dispatchServiceData }) => {
  const { config } = useSelector((state) => state.services);
  const {
    refill: { refill_days },
  } = form;
  const refillDaysValue = useMemo(() => getRefillValue(refill_days), [refill_days]);

  const onChangeDispatch = (value) => {
    dispatchServiceData({ type: types.EDIT_SERVICES_FORM_CHANGE_REFILL_DAYS, value })
  }

  const onChange = (value) => {
    const refillDayValue = getNumberValue(value);
    if (!_.isBoolean(refillDayValue)) {
      onChangeDispatch(refillDayValue);
    }
  };

  const onBlur = (value) => {
    const valueNumber = parseInt(value, 10);
    const { max_refill_days, min_refill_days } = config;
    const refillDayValue = min_refill_days;

    if (_.isNaN(valueNumber) || _.isNull(value)) {
      onChangeDispatch(refillDayValue);
    }

    if (valueNumber > max_refill_days) {
      onChangeDispatch(max_refill_days);
    }

    if (valueNumber < 2) {
      onChangeDispatch(refillDayValue);
    }
  };

  return (
    <>
      <FormGroup>
        <ControlLabel htmlFor="refill_days">Refill days</ControlLabel>
        <FormControl
          type="text"
          id="refill_days"
          name="refill_days"
          value={refillDaysValue}
          onChange={(e) => onChange(e.target.value)}
          onBlur={(e) => onBlur(e.target.value)}
        />
      </FormGroup>
    </>
  );
};

FieldRefillDays.propTypes = {
  form: PropTypes.object,
  dispatchServiceData: PropTypes.func,
}

export default FieldRefillDays;
